import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionWhitelist } from './competition-whitelist'
import { competitionWhitelistActions } from './competition-whitelist.actions'
import * as fromCompetitionWhitelist from './competition-whitelist.reducer'
import { CompetitionWhitelistService } from './competition-whitelist.service'

@Injectable()
export class CompetitionWhitelistEffects extends ResourceEffects<CompetitionWhitelist> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionWhitelistService: CompetitionWhitelistService
  ) {
    super(
      fromCompetitionWhitelist.FEATURE_NAME,
      competitionWhitelistService,
      competitionWhitelistActions,
      actions$
    )
  }
}
